import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  getConfigSuccess,
  getConfigFailure,
  getConfigSysSuccess,
  getConfigSysFailure,
  getConfigSy_LoaiTaiSanSuccess,
  getConfigSy_LoaiTaiSanFailure,
} from "actions/CauHinh";
import CauHinhApi from "service/cauHinhApi";
import { pushNotification } from "utils/notifications";
import {
  GET_CONFIG,
  GET_CONFIG_SYS,
  GET_CONFIG_SYS_LOAI_TAI_SAN,
} from "actions/CauHinh/actionTypes";

function* getConfig(action) {
  try {
    const response = yield call(CauHinhApi.getConfig, {});
    if (response.ok) {
      yield put(
        getConfigSuccess(response.data.length > 0 ? response.data[0] : {})
      );
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(getConfigFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(getConfigFailure());
  }
}

function* getConfigSys(action) {
  try {
    const response = yield call(CauHinhApi.getConfigSys, action.dataSearch);
    if (response.ok) {
      yield put(getConfigSysSuccess(response.data));
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(getConfigSysFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(getConfigSysFailure());
  }
}
function* getConfigSy_LoaiTaiSan(action) {
  try {
    const response = yield call(
      CauHinhApi.getConfigSys_LoaiTaiSan,
      action.dataSearch
    );
    if (response.ok) {
      yield put(getConfigSy_LoaiTaiSanSuccess(response.data));
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(getConfigSy_LoaiTaiSanFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(getConfigSy_LoaiTaiSanFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_CONFIG, getConfig);
  yield takeLatest(GET_CONFIG_SYS, getConfigSys);
  yield takeLatest(GET_CONFIG_SYS_LOAI_TAI_SAN, getConfigSy_LoaiTaiSan);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
